import cn from 'classnames'
import { paths } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import './navigationSwitch.scss'

interface ConfigItem {
  name: string
  path: string
  displayName: string
}

interface NavigationSwitchProps {
  selected: string
  setSelected: (arg: unknown) => void
}

const NavigationSwitch = ({ selected, setSelected }: NavigationSwitchProps) => {
  const history = useHistory()
  const location = useLocation()

  const navigationConfig: ConfigItem[] = [
    {
      name: 'reports',
      path: paths.expenseManagement.reports(),
      displayName: tr('FRONTEND.HEADER.REPORTS', 'Reports')
    },
    {
      name: 'counterparties',
      path: paths.expenseManagement.counterparties(),
      displayName: tr('FRONTEND.HEADER.COUNTERPARTY', 'Counterparties')
    }
    // {
    //   displayName: tr('FRONTEND.EXPENSES.UPLOAD_FILE.DETAILS_VIEW', 'Analytics'),
    //   name: 'test',
    //   path: paths.banking.expenses()
    // }
  ]

  const handleViewChange = (view: string) => {
    setSelected(view)
  }

  const onChangeTab = (name: string, path: string) => {
    handleViewChange(name)
    history.push(path)
  }

  useEffect(() => {
    const endPath = location?.pathname.split('/')[2]
    if (endPath && selected !== endPath) {
      setSelected(endPath)
    }
  }, [location?.pathname])

  return (
    <div className='navigation-container'>
      {navigationConfig.map(({ name, displayName, path }) => (
        <div
          key={name}
          className={cn('navigation-button', { active: selected === name })}
          onClick={() => onChangeTab(name, path)}
        >
          <span>{displayName}</span>
        </div>
      ))}
    </div>
  )
}

export default NavigationSwitch
